import { TypeRedux } from './TypeRedux'

export const ActionRedux = {
  login: (account) => ({ type: TypeRedux.LOGIN, payload: { account } }),
}
